import { CircleCheckBigIcon, CircleXIcon } from "lucide-react";
import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { api } from "../api/api";
import { email_verify_url } from "../api/urls";

const EmailVerify = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("email");
  const [isVerified, setIsVerified] = useState(false);
  useEffect(() => {
    const handleVerify = async () => {
      try {
        await api.post(email_verify_url, { data: token });
        setIsVerified(true);
      } catch (error) {
        setIsVerified(false);
      }
    };
    handleVerify();
  }, [token]);
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
      }}
    >
      <div
        style={{
          maxWidth: "400px",
          boxShadow: "2px 2px 25px lightgray",

          borderRadius: "12px",
          padding: "25px",
          textAlign: "center",
        }}
      >
        <h2
          style={{
            marginBottom: "20px",
            color: isVerified ? "green" : "red",
            display: "flex",
            gap: 4,
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          {" "}
          <span style={{ width: "32px", height: "32px" }}>
            {isVerified ? (
              <CircleCheckBigIcon style={{ width: "100%", height: "100%" }} />
            ) : (
              <CircleXIcon style={{ width: "100%", height: "100%" }} />
            )}
          </span>
          {isVerified ? "Verified!" : "Failed!"}
        </h2>
        <p style={{ marginBottom: "20px", color: "gray" }}>
          {isVerified
            ? "Your email is verified successfully!"
            : "Your email verification has been failed!"}
        </p>
        {isVerified && (
          <Link
            to={"/"}
            style={{ color: "purple", textDecoration: "underline" }}
          >
            Login
          </Link>
        )}
      </div>
    </div>
  );
};

export default EmailVerify;
